<template>
  <div class="virtual-account-container" @click.stop>
    <div class="credit-card-container" pointClass="j-open-credit-card">
      <p class="title-tips">{{ letter.pleaseCard }}</p>
      <div class="card-container" :class="{ expand: isExpand }">
        <div
          class="card-item j-credit-card-item credit-card-ico-wrap"
          v-for="(card, index) in creditCardList"
          :class="{ active: curCreditCard === card }"
          :pointValue="card"
          @click="selectCreditCard(card)"
          :key="index"
        >
          <img
            class="pay-way-icon"
            :src="getCurPayWayIcon(card)"
            alt="payway_icon"
          />
          <Icon class="check-icon" name="checked"></Icon>
        </div>
        <Icon
          v-show="creditCardList.length > 3 && !isExpand"
          class="more-icon"
          name="right"
          @click="expandList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { PAYTYPE_ICON_URL } from '@utiles/officialStore';
import { GET_CARD_SCHEMES_ACTION, SET_CREDIT_CARD } from '@store/officialTopup';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'CreditCard',
  props: {
    curPayType: {
      require: true
    },
    curLocationVal: {
      require: true
    },
    discountTransMount: {
      require: true
    },
    curCoins: {
      require: true
    },
    isCoins: {
      require: true
    }
  },
  data() {
    return {
      isExpand: false
    };
  },
  computed: {
    ...mapState({
      creditCardList: state => state.creditCardList,
      curCreditCard: state => state.creditCard,
      letter: state => state.letter
    }),
    ...mapGetters(['cartDiscountTransMount', 'isCart'])
  },
  methods: {
    getCurPayWayIcon(cardType) {
      return PAYTYPE_ICON_URL + 'credit_card/' + cardType + '.png';
    },
    selectCreditCard(card) {
      this.$store.commit(SET_CREDIT_CARD, card);
      window.webstorev3DataLayer.push({
        eventName: 'select_credit_card',
        eventValue: {
          credit_type: card
        }
      });
    },
    getCardSchemes() {
      // 金额有三种情况：购物车、非购物车、代币
      let amount = 0;
      if (this.isCart) {
        amount = this.cartDiscountTransMount;
      } else {
        amount = this.isCoins
          ? this.curCoins.TRANS_AMOUNT
          : this.discountTransMount;
      }
      this.$store.dispatch(GET_CARD_SCHEMES_ACTION, {
        currency: this.curPayType.currency,
        game_id: this.$store.state.gameId,
        location: this.curLocationVal,
        amount: amount,
        submit_type: this.isCoins ? 2 : 0 //充值代币余额时传2，否则不传或者传0
      });
    },
    expandList() {
      this.isExpand = true;
    }
  },
  created() {
    this.getCardSchemes();
  },
  watch: {
    // 如果使用优惠券则重新请求接口
    discountTransMount() {
      if (this.isCart || this.isCoins) {
        return;
      }
      this.getCardSchemes();
    },
    cartDiscountTransMount() {
      if (this.isCart) {
        this.getCardSchemes();
      }
    },
    curCoins() {
      if (this.isCoins) {
        this.getCardSchemes();
      }
    },
    curLocationVal() {
      this.getCardSchemes();
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.credit-card-container {
  width: 100%;
  min-height: 120px;
  display: flex;
  flex-direction: column;

  .card-container {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 80px;
    flex-wrap: wrap;

    &.expand {
      height: auto;
    }

    .card-item {
      border-radius: 9px;
      border: 2px solid #e8e8e8;
      margin: 5px 10px;
      position: relative;
      width: 120px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;

      .check-icon {
        position: absolute;
        width: 28px;
        height: 28px;
        color: $themeColor;
        right: 5px;
        bottom: 5px;
        display: none;
      }
      .pay-way-icon {
        border-radius: 9px;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
      }

      &.active {
        border: 2px solid $themeColor;
        position: relative;
        .check-icon {
          display: block;
        }
      }
    }
    .more-icon {
      position: absolute;
      width: 33px;
      height: 52px;
      right: 0px;
    }
  }
}
@media screen and (orientation: landscape) {
  .credit-card-container {
    min-height: 120px;
    .card-container {
      .card-item {
        margin: 5px;
        width: 99px;
        height: 58px;

        .check-icon {
          width: 25px;
          height: 25px;
          right: 2px;
          bottom: 2px;
        }
        .pay-way-icon {
          border-radius: 9px;
          width: 100%;
          height: 100%;
          background-color: #ffffff;
        }

        &.active {
          border: 2px solid $themeColor;
          position: relative;
          .check-icon {
            display: block;
          }
        }
      }
    }
  }
}
</style>
